import { jsx } from "panel";
import { ButtonBarEl } from "common/components/button-bar";
import { SelectEl } from "common/components/select";
export function template() {
  return /* @__PURE__ */ jsx(SelectEl, {
    attrs: this.helpers.getSelectAttrs(),
    class: { [`filter-${this.attr(`name`)}`]: true },
    on: {
      change: (ev) => this.helpers.handleFilterChange(ev),
      menuChange: (ev) => this.helpers.handleMenuChange(ev)
    }
  }, this.attr(`apply-button`) ? /* @__PURE__ */ jsx(ButtonBarEl, {
    sel: ".mp-button-bar-primary",
    attrs: {
      role: `button`,
      tabindex: 0,
      elref: `applyFilterButton`,
      slot: `footer`
    },
    on: {
      click: () => this.helpers.handleApplyFilterClick()
    }
  }, this.attr(`apply-button`)) : null);
}
